/**
 * NP後払い 確認画面で表示する外部リンク URL の定数。
 *
 * ドクター側 (`home_doctor_front/src/app/consts/paths.ts`) と同じ URL を使用し、
 * 規約変更時にカルテ側もここを更新すれば追従できるよう一元化する。
 */

/** 株式会社ネットプロテクションズ 公式サイト */
export const NETPROTECTIONS_URL = 'https://www.netprotections.com/';

/** NP後払い利用規約及び同社のプライバシーポリシー */
export const NP_ATOBARAI_TERMS_URL =
  'https://np-atobarai.jp/terms/atobarai-buyer.html';

/**
 * NP後払いサービス案内バナー画像のパス。
 * CRA の `public/` 配下に配置されているため import ではなく直接 URL で参照する。
 * 画像ファイル名を変更した場合はこの定数も更新すること（参照箇所は1箇所のみ）。
 */
export const NPAB_SERVICE_BANNER_IMAGE = '/assets/images/npab-service.png';
